import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Upload Pitch Deck")
], -1)
const _hoisted_3 = { class: "fv-row mb-10 d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Documents", -1)
const _hoisted_5 = { class: "row my-3" }
const _hoisted_6 = { class: "col-md-6 d-flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "align-self-center",
  for: "file"
}, "File Upload", -1)
const _hoisted_8 = { class: "col-md-6 d-flex" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "align-self-center",
  for: "url"
}, "Document URL", -1)
const _hoisted_10 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fieldChanged($event))),
            class: "mx-2 align-self-center",
            type: "radio",
            id: "file",
            name: "isPitchDeckUrl",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isPitchDeckUrl) = $event)),
            value: "0"
          }, null, 544), [
            [_vModelRadio, _ctx.isPitchDeckUrl]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fieldChanged($event))),
            class: "mx-2 align-self-center",
            type: "radio",
            id: "url",
            name: "isPitchDeckUrl",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isPitchDeckUrl) = $event)),
            value: "1"
          }, null, 544), [
            [_vModelRadio, _ctx.isPitchDeckUrl]
          ])
        ])
      ]),
      (_ctx.isPitchDeckUrl == 0)
        ? (_openBlock(), _createBlock(_component_Field, {
            key: 0,
            id: "documents",
            type: "file",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleImageUpload($event))),
            name: "pitchDeckDocument",
            accept: ".pptx, .ppt, .pdf, .xls, .xlsx",
            modelValue: _ctx.file,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.file) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.fileSizeError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " The file size must be less than 10 MBs "))
        : _createCommentVNode("", true),
      (_ctx.isPitchDeckUrl == 1)
        ? (_openBlock(), _createBlock(_component_Field, {
            key: 2,
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fieldChanged($event))),
            type: "textarea",
            name: "pitchDeckDocument",
            class: "form-control form-control-lg form-control-solid",
            modelValue: _ctx.file,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.file) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ErrorMessage, { name: "pitchDeckDocument" })
        ])
      ]),
      (_ctx.document && _ctx.isPitchDeckUrl == 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            target: "_blank",
            href: _ctx.document,
            class: "my-2"
          }, "Uploaded Document", 8, _hoisted_13))
        : _createCommentVNode("", true)
    ])
  ]))
}